import { render, staticRenderFns } from "./protect.vue?vue&type=template&id=3c9cb9ac&"
import script from "./protect.vue?vue&type=script&lang=js&"
export * from "./protect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports